import * as Sentry from '@sentry/react';

const DSN = 'https://9f39103e2f2dae8cb4cdb60f442c257a@o4511236111728640.ingest.us.sentry.io/4511236120510465';

export function initSentry() {
  if (typeof window === 'undefined') return;
  // Skip on localhost to keep your error quota for real traffic.
  const host = window.location.hostname;
  const isLocal = host === 'localhost' || host === '127.0.0.1';
  if (isLocal) return;

  Sentry.init({
    dsn: DSN,
    environment: host.includes('pkchampscoach') ? 'production' : 'staging',
    // Performance monitoring — 10% of navigations
    tracesSampleRate: 0.1,
    // Session replay — record 10% of sessions, 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
    ],
    // Don't spam the queue with third-party noise we can't fix.
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
      'Non-Error promise rejection captured',
    ],
    beforeSend(event) {
      // Drop events from browser extensions (they clutter the dashboard).
      const frames = event?.exception?.values?.[0]?.stacktrace?.frames || [];
      const fromExtension = frames.some((f) =>
        /(chrome|moz|safari)-extension:\/\//.test(f?.filename || '')
      );
      if (fromExtension) return null;
      return event;
    },
  });
}

export function setSentryUser(user) {
  if (!user) {
    Sentry.setUser(null);
    return;
  }
  Sentry.setUser({ id: user.uid });
}

export function captureMessage(msg, level = 'info') {
  Sentry.captureMessage(msg, level);
}

export { Sentry };
